import { FC, ReactNode } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';
import './AppConfirmModal.css';

export const AppConfirmModal: FC<{
    open: boolean;
    title: string;
    message: string;
    icon?: ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
}> = ({
    open,
    title,
    message,
    icon,
    confirmLabel = 'Proceed',
    cancelLabel = 'Cancel',
    onConfirm,
    onCancel,
}) => (
    <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="app-confirm-modal-title"
        className="app-confirm-modal"
    >
        <DialogTitle id="app-confirm-modal-title">
            {icon}
            {title}
        </DialogTitle>
        <DialogContent>
            <Typography variant="body1">{message}</Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
                {cancelLabel}
            </Button>
            <Button variant="outlined" onClick={onConfirm}>
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);
